import { IOpenMarketProduct } from '../../../interfaces/OpenMarketProduct.interfaces';
import { createURLSearchParams } from '../../../utils/creator/createURLSearchParams.util';
import { customAxios } from '../../common/customAxios';

export interface IGetOpenMarketProductsParams {
  searchParam: {
    status: string;
    count: number;
    page?: number;
    machineType?: string;
    machineId?: string;
    brand?: string;
    minEngineOutputPs?: number;
    maxEngineOutputPs?: number;
    minPrice?: number;
    maxPrice?: number;
    sort?: string;
    rowConfig?: string;
    minOperationTime?: number;
    maxOperationTime?: number;
    minManufacturedYear?: number;
    maxManufacturedYear?: number;
    recentDays?: number;
    region?: string;
  };
}

export const getOpenMarketProducts = ({ searchParam }: IGetOpenMarketProductsParams): Promise<IOpenMarketProduct[]> => {
  const URLSearchParams = createURLSearchParams(searchParam ?? {});
  return customAxios.get(`/user-sell-tractors?${URLSearchParams}`);
};
